import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";

import AdminTable from "../../../../../components/common/table/AdminTable";
import AdvancedSearch from "../components/advancedSearch/Filters";
import { TableExportButton } from "../../../../../components/common/table/TableExportButton";
import TableOptions from "../../../../../components/common/table/TableOptions";
import Filters from "./Filters";
import styles from "./AdminProjectMatchesTable.scss";

import { formatDateSmall, formatDateTimeLog } from "../../../../../utils/dates";
import parseAdvancedSearch from "../../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../../utils/parseFilters";
import {
  encodeSearchParams,
  getFinalQueryString,
  getPageQueryString
} from "../../../../../utils/parseQueries";
import parseSortData from "../../../../../utils/parseSortData";

const tableColumns = [
  {
    headerText: "FIRST NAME",
    accessor: "sort_first_name",
    sortable: true
  },
  {
    headerText: "LAST NAME",
    accessor: "sort_last_name",
    sortable: true
  },
  {
    headerText: "EMAIL",
    accessor: "sort_email",
    sortable: true
  },
  {
    headerText: "STATUS",
    accessor: "sort_status",
    sortable: true
  },
  {
    headerText: "NOTIFIED AT",
    accessor: "sort_notification_date",
    sortable: true,
    style: {
      alignItems: "flex-start",
      flexDirection: "column",
      justifyContent: "center"
    }
  },
  {
    headerText: "LEVEL",
    accessor: "level",
    sortable: false
  },
  {
    headerText: "METRO AREA",
    accessor: "sort_metro_area",
    sortable: true
  },
  {
    headerText: "LOCATION",
    accessor: "location",
    sortable: false
  },
  {
    headerText: "MH SKILL",
    accessor: "mh",
    sortable: true
  },
  {
    headerText: "NTH SKILL",
    accessor: "nth",
    sortable: true
  },
  {
    headerText: "LOCATION MATCH",
    accessor: "location_match",
    sortable: false
  }
];

class AdminProjectMatchesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: props.advancedSearch,
      filters: props.filters,
      selection: props.selection,
      currentPage: props.page || 1,
      showAdvancedSearch: false,
      showFilters: false
    };

    this.handleSubmitAdvancedSearch = this.handleSubmitAdvancedSearch.bind(
      this
    );
    this.handleSubmitFilters = this.handleSubmitFilters.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.openAdvancedSearch = this.openAdvancedSearch.bind(this);
    this.openFilters = this.openFilters.bind(this);
  }

  handleSubmitAdvancedSearch(data) {
    const advancedSearch = parseAdvancedSearch(data.filters);
    const filters = parseFilters(this.state.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(this.props.project.id, finalQueryString);
    this.props.getCsvData(this.props.project.id, finalQueryString);
    this.props.setPage({ table: "matches", pageNumber: 1 });
    this.props.setSort({ table: "matches", sortData: null });
    this.props.onUpdateFilters(data.filters);

    this.setState({ advancedSearch: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(data.filters, this.state.filters)
    });
  }

  handleSubmitFilters(data) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(data.filters);
    const finalQueryString = getFinalQueryString(
      filters + advancedSearch + "&filter[potential]=1"
    );

    this.props.getTable(this.props.project.id, finalQueryString);
    this.props.getCsvData(this.props.project.id, finalQueryString);
    this.props.setPage({ table: "matches", pageNumber: 1 });
    this.props.setSort({ table: "matches", sortData: null });
    this.props.onUpdateFilters(data.filters);

    this.setState({ filters: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(advancedSearch, data.filters)
    });
  }

  onPageChange(pageIndex) {
    window.scrollTo(0, 0);

    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(this.props.sortData);
    const pageQuery = getPageQueryString(pageIndex);
    const finalQueryString = getFinalQueryString(
      pageQuery + filters + advancedSearch + sort + "&filter[potential]=1"
    );

    this.props.getTable(this.props.project.id, finalQueryString);
    this.props.setPage({ table: "matches", pageNumber: pageIndex + 1 });

    this.setState({ currentPage: pageIndex + 1 });
  }

  onSortChange(sortData) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(sortData);
    const finalQueryString = getFinalQueryString(
      filters + advancedSearch + sort + "&filter[potential]=1"
    );

    this.props.getTable(this.props.project.id, finalQueryString);
    this.props.setPage({ table: "matches", pageNumber: 1 });
    this.props.setSort({ table: "matches", sortData });

    this.setState({ currentPage: 1 });
  }

  openAdvancedSearch() {
    this.setState({ showAdvancedSearch: true });
  }

  openFilters() {
    this.setState({ showFilters: true });
  }

  onUpdateSelection = value => {
    this.setState({
      selection: value
    });
  };

  getStatusRow(match) {
    let status = match.potential ? "Potential" : "Matched";

    if (match.declined === true) {
      status = "Declined";
    }

    if (match.pitch && match.pitch.accepted === false) {
      status = "Pitch Rejected";
    }

    return status;
  }

  getNotifiedRow(match) {
    const notifications = match.notifications.map(n => (
      <span key={n.sent_at.toString()}>{formatDateTimeLog(n.sent_at)}</span>
    ));

    return notifications ? notifications : "-";
  }

  getLastActivityRow(match) {
    return match.updated_at ? formatDateSmall(match.updated_at) : "";
  }

  getLocationMatchRow(match, project) {
    if (project.city) {
      return _.get(match.member.profile, "commute_city.value") ===
        project.city.replace(", USA", "")
        ? "Yes"
        : _.get(match.member.profile, "city") === project.city
        ? "Yes"
        : "No";
    }
  }

  getTableData(target) {
    const project = this.props.project;
    const matches =
      target === "csv" ? this.props.matches_csv : this.props.matches;

    let data = matches.map(match => {
      return {
        id: match.id,
        sort_first_name: (
          <Link to={`/admin/member/approved/${match.member.id}/profile`}>
            {match.member.first_name}
          </Link>
        ),
        sort_last_name: (
          <Link to={`/admin/member/approved/${match.member.id}/profile`}>
            {match.member.last_name}
          </Link>
        ),
        sort_email: _.get(match, "member.email"),
        sort_status: this.getStatusRow(match),
        sort_notification_date: this.getNotifiedRow(match),
        level: _.get(match, "member.profile.level.value"),
        sort_metro_area: _.get(match, "member.profile.commute_city.value"),
        location: _.get(match, "member.profile.city"),
        mh: _.get(match, "mh"),
        nth: _.get(match, "nth"),
        location_match: this.getLocationMatchRow(match, project)
      };
    });

    return data;
  }

  render() {
    return (
      <div>
        <AdvancedSearch
          show={this.state.showAdvancedSearch}
          onClose={() => this.setState({ showAdvancedSearch: false })}
          onSubmit={this.handleSubmitAdvancedSearch}
        />
        <Filters
          show={this.state.showFilters}
          onClose={() => this.setState({ showFilters: false })}
          onSubmit={this.handleSubmitFilters}
        />
        <TableOptions
          tableColumns={tableColumns}
          title="Potential Matches / All"
          paginationCount={this.props.paginationCount}
          filtersNumber={this.state.filters && this.state.filters.length}
          searchsNumber={
            this.state.advancedSearch && this.state.advancedSearch.length
          }
          onFilterClick={this.openFilters}
          onSearchClick={this.openAdvancedSearch}
        />
        <div className={styles.projects}>
          <AdminTable
            page={this.state.currentPage - 1}
            tableData={this.getTableData()}
            tableColumns={tableColumns}
            loading={this.props.loading}
            selectable={true}
            numberOfPages={this.props.numberOfPages}
            onPageChange={this.onPageChange}
            noRowsText="No matches found"
            sortData={this.props.sortData}
            onSortChange={this.onSortChange}
            onUpdate={this.props.onUpdateSelection}
            style={{
              height: "640px"
            }}
          />
        </div>
        <Col
          lg={2}
          md={2}
          sm={2}
          style={{ textAlign: "center", paddingTop: "1.5em" }}
        >
          <TableExportButton
            tableColumns={tableColumns}
            tableData={this.getTableData("csv")}
          />
        </Col>
      </div>
    );
  }
}

export default AdminProjectMatchesTable;



// WEBPACK FOOTER //
// ./src/routes/admin/project/potentialMatches/components/AdminProjectMatchesTable.js